import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface Props {
  path: string;
  // 경로 앞에 붙는 라벨 — 기본값은 스마트스토어다. KREAM 등 다른 채널이면 넘겨준다.
  label?: string;
}

// 판매자센터에서 찾아 들어갈 메뉴 경로 — 설정 모달마다 같은 모양으로 맨 위에 붙는다.
function PathPickStartGuideMenuPath({ path, label }: Props) {
  const { t } = useI18nHelper();

  return (
    <Flex
      gap={"6px"}
      alignItems={"center"}
      flexWrap={"wrap"}
      padding={"8px 12px"}
      borderRadius={"4px"}
      backgroundColor={"#E8F2FF"}
    >
      <Text textStyle={"caption-bold"} color={"#6F6F6C"} flexShrink={0}>
        {label ?? t("path_pick_guide:menu_path_label")}
      </Text>
      <Text textStyle={"body-sm-bold"} color={"#1272EF"}>
        {path}
      </Text>
    </Flex>
  );
}

export default PathPickStartGuideMenuPath;
